import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const product = 'Atlas Visuel de Biomécanique + 6 bonus';
const notices = [{
  name: 'Camila R.',
  city: 'Guadalajara, Mexique',
  product
}, {
  name: 'Nicolás B.',
  city: 'Medellín, Colombie',
  product
}, {
  name: 'Sofía D.',
  city: 'Lima, Pérou',
  product
}, {
  name: 'Andrés V.',
  city: 'Santiago, Chili',
  product
}, {
  name: 'Valeria P.',
  city: 'Quito, Équateur',
  product
}, {
  name: 'Mateo G.',
  city: 'Córdoba, Argentine',
  product
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % notices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = notices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-221" data-mp="285qxd3zlqruw">
      <AnimatePresence data-id="element-222" data-mp="1bhkxsvhjepnh">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} aria-live="polite" className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-2xl bg-white p-4 shadow-lg ring-1 ring-blue-100" data-id="element-223" data-mp="1fh3cvamog6ie">
            <div className="min-w-0 flex-1" data-id="element-224" data-mp="wpj1tmil8gsq">
              <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-widest text-emerald-600" data-id="element-225" data-mp="201rfpi641ke0">
                <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-226" data-mp="1v1vc3k1bruyz" />
                Achat vérifié
              </p>
              <p className="mt-2 text-sm font-bold text-slate-900" data-id="element-227" data-mp="28wfkz8bor22t">
                {notice.name} de {notice.city}
              </p>
              <p className="truncate text-sm text-blue-900/70" data-id="element-228" data-mp="1h2vli6u95606">
                A acheté <span className="font-semibold text-blue-700" data-id="element-229" data-mp="1h59iwmcemuaw">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-blue-900/45" data-id="element-230" data-mp="1c6eyxh2pazp7">Il y a 2 minutes</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer la notification" className="rounded-md p-1 text-blue-900/40 transition-colors duration-150 ease-out hover:bg-blue-50 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-231" data-mp="1q1qvzv4bx29a">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-232" data-mp="34zcyfy06msl5" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}